export function getBrowserData() {
  const { ClientJS } = require('clientjs');
  const client = new ClientJS();

  return {
    deviceOs: client.getOS(),
    browser: client.getBrowser(),
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    language: client.getLanguage(),
    currentResolution: client.getCurrentResolution(),
    plugins: client.getPlugins(),
    userAgent: client.getUserAgent(),
    fonts: client.getFonts()
  };
}
